import { apiCall } from "../../../services/api-service.js";

export const getNfcList = async (params) => {
  return await apiCall("GET", `nfc_master`, null, { params });
};

export const updateNfcStatus = async (data) => {
  return await apiCall("PUT", `nfc_master/status_update/${data.id}`, data);
};

export const getNfcDetails = async (id) => {
  return await apiCall("GET", `nfc_master/${id}`);
};

export const deleteNfc = async (id) => {
  return await apiCall("DELETE", `nfc_master?id=${id}`);
};

export const getNfcHistory = async (id, params) => {
  return await apiCall("GET", `nfc_master/history/${id}`, null, { params });
};

export const getNfcChartData = async (id, params) => {
  return await apiCall("GET", `nfc_master/chart/${id}`, null, { params });
};
